import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Sprint 12+M5.11 (19.07.2026) — Harte Trennung Pionier ↔ Free/Paid:
// Pionier-Routen redirecten UNAUTHENTICATED-User NIE auf /login (das wuerde
// den User in den Free/Paid-Login-Flow werfen). Stattdessen zurueck zur
// Pionier-Bridge /warteliste/one-click, wo der User seine Email erneut
// eingeben kann und einen neuen Magic-Link bekommt.
export default function ProtectedRoute({
  children,
  requirePionier = false,
  unauthenticatedRedirect,
}) {
  const { user } = useAuth();
  const location = useLocation();

  // Fallback: Pionier-Routen → Pionier-Bridge, sonst /login (Free/Paid)
  const redirectTo =
    unauthenticatedRedirect ||
    (requirePionier ? "/warteliste/one-click" : "/login");

  if (user === null) {
    return (
      <div className="flex items-center justify-center min-h-screen" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 text-[#1E40AF] animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }
  if (requirePionier && (!user?.is_pionier || user?.pionier_active !== true)) {
    // Sprint 12+ Cockpit-Hotfix (03.07.2026): Free-User sollen nicht in den
    // Pionier-Cockpit-Loop rutschen — Redirect auf ihr normales Dashboard.
    //
    // Post-Launch-H5 (10.02.2026) — PIONIER-Switch-Konsistenz (Boardroom-CoS):
    // Zusätzlicher Guard `pionier_active !== true`. Wenn Env-Flag
    // PIONIER_ACTIVE=false, sollen selbst is_pionier=true User beim manuellen
    // Direkt-Aufruf von /dashboard/pionier ins Free-Dashboard umgeleitet
    // werden. Zielroute bleibt bewusst `/dashboard` (nicht `/cockpit`), damit
    // wir keine bestehenden Tests / Deep-Links brechen — /dashboard routet
    // dann standard-mäßig zum passenden Cockpit weiter.
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
